import React from 'react'

export const TENANT_TYPE = { ALL: 0, BOOK: 1, ASSIGN: 2 }
const CurrentUserContext = React.createContext()

export default CurrentUserContext
